'use client';
import Link from 'next/link';
import Navbar from '@/components/ui/Navbar';
import Footer from '@/components/ui/Footer';

const CONTACT_EMAIL = 'info@reprintsolution.online';
const LAST_UPDATED = '1 June 2026';

export default function DisclaimerPage() {
  return (
    <div className="min-h-screen bg-[#030812] text-white">
      <Navbar />
      <main>
        <section className="border-b border-white/10 bg-[linear-gradient(135deg,#07111f_0%,#0f1f3d_100%)] py-16">
          <div className="container mx-auto max-w-4xl px-4">
            <nav className="mb-6 flex items-center gap-2 text-sm text-slate-400">
              <Link href="/" className="hover:text-white transition">Home</Link>
              <span>/</span>
              <span className="text-white">Disclaimer</span>
            </nav>
            <h1 className="text-3xl font-black text-white md:text-4xl">Disclaimer</h1>
            <p className="mt-3 text-slate-400 text-sm">Last updated: {LAST_UPDATED}</p>
          </div>
        </section>

        <section className="py-14">
          <div className="container mx-auto max-w-4xl px-4">
            <div className="space-y-8 text-sm leading-7 text-slate-300">

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">General Disclaimer</h2>
                <p className="mt-3">
                  The information provided on the RePrint Solution website is for general informational purposes only. While we strive to keep the information up to date and accurate, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of the information, products, services, or related graphics contained on the website.
                </p>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Trademark Disclaimer</h2>
                <p className="mt-3">
                  RePrint Solution is an independent refurbished printer retailer and is <strong className="text-white">not affiliated with, sponsored by, or endorsed by</strong> any printer manufacturer or brand including but not limited to HP, Canon, Epson, Brother, Lexmark, Samsung, or any other brand.
                </p>
                <p className="mt-3">
                  All brand names, product names, logos, and trademarks mentioned on this website are the property of their respective owners. Any use of these names is solely for identification and descriptive purposes.
                </p>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Product Information Disclaimer</h2>
                <p className="mt-3">
                  Product specifications, descriptions, and images are provided for informational purposes. Actual products may vary slightly from descriptions. Refurbished products may show minor cosmetic wear consistent with their stated condition grade. We make every effort to accurately describe condition grades but cannot guarantee that descriptions are error-free.
                </p>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Advertising Disclaimer</h2>
                <p className="mt-3">
                  This website displays advertisements served by Google AdSense and other third-party advertising networks. These advertisements are clearly labelled. We do not endorse the products or services advertised. Clicking on advertisements may direct you to third-party websites over which we have no control.
                </p>
                <p className="mt-3">
                  We may receive compensation for displaying advertisements. This does not influence our product listings, reviews, or editorial content.
                </p>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">External Links Disclaimer</h2>
                <p className="mt-3">
                  Our website may contain links to external websites. These links are provided for convenience only. We have no control over the content of those sites and accept no responsibility for them or for any loss or damage that may arise from your use of them.
                </p>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Limitation of Liability</h2>
                <p className="mt-3">
                  In no event will RePrint Solution be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arising out of, or in connection with, the use of this website.
                </p>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Contact</h2>
                <p className="mt-3">
                  If you have any questions about this disclaimer, please contact us at:{' '}
                  <a href={`mailto:${CONTACT_EMAIL}`} className="text-violet-400 hover:text-violet-300 underline">{CONTACT_EMAIL}</a>
                </p>
              </div>

            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
